import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../endPoints/endPoints";
import { ILandCategory, IOptionType } from "../interfaces/IlandCategory";

export const landCategoryApi = createApi({
  reducerPath: "landcategory",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.LANDCATEGORY,
  }),
  tagTypes: ["landcategory"],
  endpoints: (builder) => ({
    getLandCategories: builder.query<IOptionType[], void>({
      query() {
        return {
          url: ``,
          method: "GET",
          credentials: "include",
        };
      },
      transformResponse: (resp: ILandCategory[]) => {
        return resp.map(item => ({
            id: item.code,
            title: item.short
        }))
      },
      providesTags: ["landcategory"],
    }),
  }),
});

export const { useGetLandCategoriesQuery } = landCategoryApi;